import React from 'react'
import './index.less'

const qrCodeImg = require('../../assets/images/qrCode.png')

const basicInfoForm = () => (
  <div className="content">
    <img className="codeImg" alt="二维码" src={qrCodeImg} />
    <p className="codeTips">
      扫描二维码
      <br />
      登录京东APP 领取新人专享福利
    </p>
  </div>
)

export default basicInfoForm
